import { render, staticRenderFns } from "./Brandanalytic.vue?vue&type=template&id=6f8090ee&scoped=true"
import script from "./Brandanalytic.vue?vue&type=script&lang=js"
export * from "./Brandanalytic.vue?vue&type=script&lang=js"
import style0 from "./Brandanalytic.vue?vue&type=style&index=0&id=6f8090ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8090ee",
  null
  
)

export default component.exports